import { Fragment } from 'react'
import PropTypes from 'prop-types'

const LoginButton = ({ trigger }) => (
  <Fragment>
    <h2 className="align-center">Faça o login para visualizar e começar a adicionar seus produtos favoritos</h2>
    <ul className="wishlist-collection">
      <li className="wishlist-collection-item">
        <button
          className="button button-primary button-full no-shadow radius"
          onClick={trigger}>
          Fazer Login
        </button>
      </li>
    </ul>
  </Fragment>
)
const RenderDesktop = ({ trigger }) => (
  <div className="container wishlist-home-screen">
    <div className="wishlist-loggin">
      <h1 className="title">Minhas Listas de Favoritos</h1>
      <LoginButton trigger={trigger} />
    </div>
    <div>
      <figure>
        <img
          src="/assets/frontend/images/wishlist-empty-desktop.svg"
          alt="Faça o login para visualizar e começar a adicionar seus produtos favoritos"
          width="100%" />
      </figure>
    </div>
  </div>
)

const RenderMobile = ({ trigger }) => (
  <div className="container wishlist-home-screen">
    <figure>
      <img
        src="/assets/frontend/images/wishlist-empty.svg"
        alt="Faça o login para visualizar e começar a adicionar seus produtos favoritos" />
    </figure>
    <LoginButton trigger={trigger} />
  </div>
)

const HomeScreen = ({ trigger }) => (
  window.innerWidth >= 768
    ? <RenderDesktop trigger={trigger} />
    : <RenderMobile trigger={trigger} />
)

HomeScreen.propTypes = {
  trigger: PropTypes.func.isRequired
}

export default HomeScreen
